// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__bVfKy","is-dragging":"styles_is-dragging__3t4uM"};